import React, { useState, useEffect } from 'react';
import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  Select,
  MenuItem,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextComponent from 'components/Input/TextComponent';
import SelectComponent from 'components/Input/SelectComponent';
import { DataMap } from '@grapecity/wijmo.grid';

import { useRestApi } from 'context/RestApiContext';
import { useMaster } from 'context/MasterContext';
import { MessageModal } from 'components/modal/MessageModal';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { checkRequired } from 'utils/validationUtils';
import { format } from 'date-fns';

// 年間管理の編集用のモーダル
function YearManageModal(props) {
  const restApi = useRestApi();
  const master = useMaster();

  // コードマッピング
  var yearManageWorksMap = new DataMap([...master.yearManageWorks], 'id', 'name');

  const [show, setShow] = useState(false);
  // メッセージダイアログ
  const [dialog, setDialog] = useState({});
  // エラーフィールド
  const [errorFileds, setErrorFileds] = useState([]);
  // 年間管理ヘッダ
  const [yearManage, setYearManage] = useState({
    SUM_KIN: 0,
  });
  const handleClose = () => setShow(false);

  useEffect(() => {
    setErrorFileds([]);

    if (props?.params?.mode == 'add') {
      restApi.get(
        `/api/year_manage/${props?.params.client.CLIENT_CD}/${props?.params.client.DM_NO}`,
        (data) => {
          setYearManage({
            ...data,
            YEAR: new Date().getFullYear(),
            M1_WORK: toWorkArray(data.M1_WORK),
            M2_WORK: toWorkArray(data.M2_WORK),
            M3_WORK: toWorkArray(data.M3_WORK),
            M4_WORK: toWorkArray(data.M4_WORK),
            M5_WORK: toWorkArray(data.M5_WORK),
            M6_WORK: toWorkArray(data.M6_WORK),
            M7_WORK: toWorkArray(data.M7_WORK),
            M8_WORK: toWorkArray(data.M8_WORK),
            M9_WORK: toWorkArray(data.M9_WORK),
            M10_WORK: toWorkArray(data.M10_WORK),
            M11_WORK: toWorkArray(data.M11_WORK),
            M12_WORK: toWorkArray(data.M12_WORK),
          });
          setShow(true);
        }
      );
    } else if (props?.params?.mode == 'upd') {
      restApi.get(`/api/year_manage/${props?.params.yearManage.MANAGE_ID}`, (data) => {
        console.log(data);
        setYearManage({
          ...data,
          M1_WORK: toWorkArray(data.M1_WORK),
          M2_WORK: toWorkArray(data.M2_WORK),
          M3_WORK: toWorkArray(data.M3_WORK),
          M4_WORK: toWorkArray(data.M4_WORK),
          M5_WORK: toWorkArray(data.M5_WORK),
          M6_WORK: toWorkArray(data.M6_WORK),
          M7_WORK: toWorkArray(data.M7_WORK),
          M8_WORK: toWorkArray(data.M8_WORK),
          M9_WORK: toWorkArray(data.M9_WORK),
          M10_WORK: toWorkArray(data.M10_WORK),
          M11_WORK: toWorkArray(data.M11_WORK),
          M12_WORK: toWorkArray(data.M12_WORK),
        });
        setShow(true);
      });
    }
  }, [props.params]);

  // カンマ区切りの文字列を配列に変換
  const toWorkArray = (work) => {
    if (!work) return [];
    return work.split(',').map((x) => parseInt(x));
  };

  // 編集処理
  const handleOnChange = (prop) => (target) => {
    setYearManage({ ...yearManage, [prop]: target?.value ?? target?.target.value });
    // エラーをクリア
    setErrorFileds([...errorFileds].filter((x) => x != prop));
  };

  // 作業月の編集
  const handleOnChangeMonth = (prop) => (event) => {
    setYearManage({ ...yearManage, [prop]: event.target?.checked ? 1 : 0 });
  };

  // 入力チェック
  const validate = () => {
    let errors = [];
    checkRequired(yearManage.TITLE, '邸名', 'TITLE', errors);
    checkRequired(yearManage.LAST_UPDATE, '更新日', 'LAST_UPDATE', errors);
    Array.from({ length: 12 }, (_, i) => i + 1).forEach((i) => {
      if (yearManage[`M${i}`] == 1) {
        checkRequired(yearManage[`M${i}_WORK`], `${i}月の作業内容`, `M${i}_WORK`, errors, true);
      }
    });

    setErrorFileds(errors.flatMap((x) => x.fields));

    return errors.map((x) => x.msg);
  };

  // 保存ボタンをクリック
  const hendleClickSave = () => {
    // 入力チェック
    var error = validate();
    if (error.length > 0) {
      setDialog({
        type: 'error',
        message: error,
      });
      return;
    }

    console.log(yearManage);

    restApi.post(
      `/api/year_manage/${props.params.mode}/${props.params.client.CLIENT_CD}`,
      { ...yearManage, LAST_UPDATE: format(yearManage.LAST_UPDATE, 'yyyy/MM/dd') },
      (_) => {
        props.callback();
        setShow(false);
      }
    );
  };

  return (
    <>
      <Dialog
        sx={{
          '& .MuiDialog-container': {
            alignItems: 'flex-start',
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: '1080px',
              backgroundColor: '#f1f2f4',
              marginTop: '40px',
            },
          },
        }}
        open={show}
        disableEnforceFocus={true} // フォーカス制御を無効にする
      >
        <DialogTitle>
          年間管理
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Card className="m-0 p-2">
            <Row>
              <Col className="pr-1" md="8">
                <Form.Group>
                  <label>邸名</label>
                  <TextComponent
                    type="text"
                    value={yearManage.TITLE}
                    onChange={handleOnChange('TITLE')}
                    error={errorFileds.some((x) => x == 'TITLE')}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col className="pr-1" md="2">
                <label>西暦</label>
                <SelectComponent value={yearManage.YEAR} onChange={handleOnChange('YEAR')}>
                  {Array.from({ length: new Date().getFullYear() - 2018 + 2 }, (_, i) => 2018 + i)
                    .reverse()
                    .map((i) => (
                      <option key={i} value={i}>
                        {i}年
                      </option>
                    ))}
                </SelectComponent>
              </Col>
              <Col md="3">
                <label>更新日</label>
                <TextComponent
                  type="date"
                  value={yearManage.LAST_UPDATE}
                  onChange={handleOnChange('LAST_UPDATE')}
                  error={errorFileds.some((x) => x == 'LAST_UPDATE')}
                ></TextComponent>
              </Col>
              <Col md="2">
                <label>価格</label>
                <TextComponent
                  max={999999999}
                  type="number"
                  value={yearManage.KAKAKU}
                  onChange={handleOnChange('KAKAKU')}
                ></TextComponent>
              </Col>
            </Row>

            <Row className="mt-2">
              <Col className="pr-1 pr-4" md="12">
                <label>作業内容</label>
                <TextComponent
                  className="form-control"
                  type="text"
                  value={yearManage?.DESCRIPTION}
                  onChange={handleOnChange('DESCRIPTION')}
                ></TextComponent>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col className="pr-1" md="12">
                <label>作業月</label>
              </Col>
            </Row>
            {Array.from({ length: 6 }, (_, i) => i * 2 + 1).map((i) => (
              <Row className="mt-2">
                <Col className="pr-1" md="5" style={{ display: 'flex' }}>
                  <label
                    className="mr-3 mt-1"
                    style={{ fontSize: '14pt', color: 'black', whiteSpace: 'nowrap', width: 60 }}
                  >
                    <input
                      className="ml-2"
                      style={{ transform: 'scale(1.5)' }}
                      type="checkbox"
                      checked={yearManage[`M${i}`] == 1}
                      onChange={handleOnChangeMonth(`M${i}`)}
                    ></input>
                    &nbsp;{`${i}`}月
                  </label>

                  <Select
                    multiple
                    displayEmpty
                    disabled={yearManage[`M${i}`] != 1}
                    className="ml-2"
                    style={{ height: '38px', width: '320px' }}
                    variant="standard"
                    value={yearManage[`M${i}_WORK`]}
                    renderValue={(x) => {
                      if (x?.length === 0) {
                        return (
                          <em className="pl-2" style={{ color: '#ababab' }}>
                            作業内容を選択
                          </em>
                        );
                      }
                      return (
                        <div className="pl-1">
                          {x.map((id) => yearManageWorksMap.getDisplayValue(id)).join('・')}
                        </div>
                      );
                    }}
                    onChange={(e) => {
                      console.log(e.target.value);
                      setYearManage({ ...yearManage, [`M${i}_WORK`]: e.target.value });
                    }}
                  >
                    <MenuItem disabled value="">
                      <em>作業内容を選択</em>
                    </MenuItem>
                    {master.yearManageWorks.map((x) => (
                      <MenuItem key={x.id} value={x.id} className="m-0 p-0">
                        <Checkbox
                          checked={yearManage[`M${i}_WORK`]?.indexOf(x.id) > -1}
                          className="m-0 ml-2 p-1"
                        />
                        <h5 className="m-0 p-0">{x.name}</h5>
                      </MenuItem>
                    ))}
                  </Select>
                </Col>
                <Col className="pr-1" md="5" style={{ display: 'flex' }}>
                  <label
                    className="mr-3 mt-1"
                    style={{ fontSize: '14pt', color: 'black', whiteSpace: 'nowrap', width: 60 }}
                  >
                    <input
                      className="ml-2"
                      style={{ transform: 'scale(1.5)' }}
                      type="checkbox"
                      checked={yearManage[`M${i + 1}`] == 1}
                      onChange={handleOnChangeMonth(`M${i + 1}`)}
                    ></input>
                    &nbsp;{`${i + 1}`}月
                  </label>
                  <Select
                    multiple
                    displayEmpty
                    disabled={yearManage[`M${i + 1}`] != 1}
                    className="ml-2"
                    style={{ height: '38px', width: '320px' }}
                    variant="standard"
                    value={yearManage[`M${i + 1}_WORK`]}
                    renderValue={(x) => {
                      if (x?.length === 0) {
                        return (
                          <em className="pl-2" style={{ color: '#ababab' }}>
                            作業内容を選択
                          </em>
                        );
                      }
                      return (
                        <div className="pl-1">
                          {x.map((id) => yearManageWorksMap.getDisplayValue(id)).join('・')}
                        </div>
                      );
                    }}
                    onChange={(e) => {
                      setYearManage({ ...yearManage, [`M${i + 1}_WORK`]: e.target.value });
                    }}
                  >
                    <MenuItem disabled value="">
                      <em>作業内容を選択</em>
                    </MenuItem>
                    {master.yearManageWorks.map((x) => (
                      <MenuItem key={x.id} value={x.id} className="m-0 p-0">
                        <Checkbox
                          checked={yearManage[`M${i + 1}_WORK`]?.indexOf(x.id) > -1}
                          className="m-0 ml-2 p-1"
                        />
                        <h5 className="m-0 p-0">{x.name}</h5>
                      </MenuItem>
                    ))}
                  </Select>
                </Col>
              </Row>
            ))}
          </Card>
        </DialogContent>
        <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
          <Button variant="secondary" className="footer-button" onClick={handleClose}>
            閉じる
          </Button>
          <Button
            variant="primary"
            className="btn-fill footer-button ml-4 mr-2"
            onClick={hendleClickSave}
            style={{ flexGrow: 1 }}
          >
            保存
          </Button>
        </DialogActions>
      </Dialog>
      {/* メッセージダイアログ */}
      <MessageModal dialog={dialog}></MessageModal>
    </>
  );
}
export default YearManageModal;
